export const FETCH_RETAILER_ATTRIBUTES_REQUEST = "FETCH_RETAILER_ATTRIBUTES_REQUEST";
export const FETCH_RETAILER_ATTRIBUTES_SUCCESS = "FETCH_RETAILER_ATTRIBUTES_SUCCESS";
export const FETCH_RETAILER_ATTRIBUTES_ERROR = "FETCH_RETAILER_ATTRIBUTES_ERROR";
export const UPDATE_RETAILER_ATTRIBUTES = "UPDATE_RETAILER_ATTRIBUTES";